<template>
    <div class="w-full flex flex-row mb-3 xl:mb-5 align-items-center cursor-pointer 
        xl:max-w-30rem lg:max-w-30rem md:max-w-30rem"
        @click="openScanner">
        <div class="w-full flex flex-row border-round-2xl surface-300 py-5 px-3">
            <span class="flex flex-1 text-700 font-medium xl:text-xl">
                {{ content[lang_].btn }}
            </span>
            <i class="pi pi-qrcode text-700" style="font-size: 1rem"></i>
        </div>
    </div> 

    <Dialog v-model:visible="openedScanner" modal :header="content[lang_].header" 
        class="w-full ml-4 mr-4 border-round-xl" style="max-width: 560px;">
        <qrcode-stream v-if="openedScanner && !loading && !pause" @detect="onDetect"></qrcode-stream>
        <div v-if="loading || pause" class="flex flex-row text-xl align-items-center justify-content-center my-4">
            <i v-if="loading" class="pi pi-spin pi-spinner mr-3 text-primary" style="font-size:2rem"></i>
            <span v-if="loading">{{ content[lang_].loading }}</span>
            <i v-if="pause" class="pi pi-check mr-3 text-green-200" style="font-size:2rem"></i>
            <span v-if="pause">{{ content[lang_].sent }}</span>
        </div>
    </Dialog>
</template>


<script>
import Connect from '@/assets/js/Connect'
import { QrcodeStream, QrcodeDropZone, QrcodeCapture } from 'vue-qrcode-reader'

export default {
    name: 'QRscaner',
    props: ['transfer_id'],
    data() {
        return {
            openedScanner: false,
            loading: false,
            pause: false,
            detectedCodes: [],
            content: {
                ru: {
                    btn: 'Сканировать QR код',
                    header: 'Наведите на QR код',
                    loading: 'Отправка...',
                    sent: 'Отправлено',
                },
                en: {
                    btn: 'Scan QR code',
                    header: 'Point to QR code',
                    loading: 'Sending...',
                    sent: 'Sent',
                }
            }
        }
    },
    components: {
        QrcodeStream
    },
    computed: {
		lang_() {
			return (this.$i18n.locale) ? this.$i18n.locale : 'ru'
		},
	},
    methods: {
        openScanner() {
            this.openedScanner = true
        },
        async onDetect (detectedCodes) {
            if(!this.transfer_id) return 
            if(this.loading || this.pause) return
            if(!detectedCodes) return
            if(detectedCodes.length === 0) return

            this.loading = true

            const request = await this.connect.send_qr(detectedCodes[0].rawValue, this.transfer_id).then(res => res)
            if(request.result && request.data) {
                this.pause = true
                setTimeout(() => {
                    this.pause = false
                    this.openedScanner = false
                }, 5000)
            } else {
                this.openedScanner = true
                this.showMess('error', 'Error', request.errors[0])
            }
            this.loading = false
        },
        showMess(severity, summary, detail) {
            this.$toast.add({severity: severity, summary: summary, detail: detail, life: 3000});
        },
    },
    beforeCreate() {
        this.connect = new Connect()
    },
}
</script>
